module.exports = __webpack_public_path__ + "img/60ne.7aed1199.svg";